import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const ExitFullScreen = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg ref={ref} {...props} viewBox="0 0 14 14">
          <path
            d="M0 5H5V2.38419e-07M9 0V5H14M0 9H5V14M9 14V9H14"
            stroke="#0F0F14"
          />
        </svg>
      </Icon>
    );
  },
);

ExitFullScreen.displayName = "ExitFullScreen";
